// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : parts for presenation nodes
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import log from 'uix/logging'
import {loadLazy} from 'uix/parts'

// ---Local imports

// ---Globals
export const PresentationEditor = loadLazy(() =>
  import(/* webpackChunkName: 'presentation' */ './editor')
)

export const PresentationViewer = loadLazy(() =>
  import(/* webpackChunkName: 'presentation' */ './viewer')
)
